import React, { useEffect, createElement } from 'react';
import { initPixel } from './utils/pixel';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { TrustSection } from './components/TrustSection';
import { WhyItWorksSection } from './components/WhyItWorksSection';
import { PricingSection } from './components/PricingSection';
import { OrderBumpSection } from './components/OrderBumpSection';
import { FinalCloseSection } from './components/FinalCloseSection';
import { SalesFooter } from './components/SalesFooter';
export function App() {
  useEffect(() => {
    // Page title
    document.title = 'The Quiet Bladder Reset — Sleep a Full Block Again';
    // Meta description
    const metaDesc = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDesc.setAttribute('name', 'description');
    metaDesc.setAttribute('content', 'Stop the 2 AM bathroom march. A simple evening protocol that helps men sleep through the night — without "no water" rules. Instant digital download for $6.36.');
    if (!document.querySelector('meta[name="description"]')) {
      document.head.appendChild(metaDesc);
    }
    // Open Graph tags (for link previews on social/messaging)
    const ogTags = [{
      property: 'og:title',
      content: 'The Quiet Bladder Reset — Sleep a Full Block Again'
    }, {
      property: 'og:description',
      content: 'Stop the 2 AM bathroom march. A simple evening protocol that helps men sleep through the night. $6.36 instant download.'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/eaeiA9xEHpLhgxY32Yqn21/heylloyd-image-1771004141966.jpg'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:url',
      content: 'https://quietbladderreset.betterbysteps.com'
    }];
    ogTags.forEach(({
      property,
      content
    }) => {
      const existing = document.querySelector(`meta[property="${property}"]`);
      if (existing) {
        existing.setAttribute('content', content);
      } else {
        const meta = document.createElement('meta');
        meta.setAttribute('property', property);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    });
    // Init pixel
    initPixel();
  }, []);
  return <div className="min-h-screen bg-warm-white text-charcoal font-sans antialiased selection:bg-sage/30" data-id="element-0">
      <main className="flex flex-col w-full" data-id="element-1">
        {/* 1. Hero: Hook + Image + CTA + Prose */}
        <HeroSection data-id="element-2" />

        {/* 2. Pain: Agitate the problem */}
        <PainSection data-id="element-3" />

        {/* 3. Failed Solutions: Why other things didn't work */}
        <FailedSolutionsSection data-id="element-4" />

        {/* 4. Mechanism: The solution + Mid-page CTA */}
        <MechanismSection data-id="element-5" />

        {/* 5. Value Stack: What they get */}
        <WhatYouGetSection data-id="element-6" />

        {/* 6. Why It Works: Logic bridge before price */}
        <WhyItWorksSection data-id="element-7" />

        {/* 7. Pricing + Order Bump: The offer */}
        <PricingSection data-id="element-8" />
        <OrderBumpSection data-id="element-9" />

        {/* 8. Trust: Objection handling post-price */}
        <TrustSection data-id="element-10" />

        {/* 9. Final Close: Emotional appeal + CTA */}
        <FinalCloseSection data-id="element-11" />
      </main>
      <SalesFooter data-id="element-12" />
    </div>;
}